module.exports = __webpack_public_path__ + "img/home-project-furniture.194b154e.jpg";